export default {
  title: "Profil",
  description: "Gérez votre profil utilisateur",
  
  photo: {
    alt: "Photo de profil",
    upload: "Télécharger une photo",
    change: "Changer la photo",
    remove: "Supprimer la photo"
  },
  
  form: {
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    save: "Enregistrer les modifications"
  },
  
  messages: {
    updateSuccess: "Profil mis à jour avec succès",
    updateError: "Erreur lors de la mise à jour du profil",
    photoUploadSuccess: "Photo téléchargée avec succès",
    photoUploadError: "Erreur lors du téléchargement de la photo"
  }
}; 